import { useEffect, useRef } from 'react';

const DUCK_RESTORE_DELAY_MS = 3000;

/**
 * Manages system audio ducking during conversation (Electron only).
 * Ducks Spotify/Music when Aria is speaking or user is talking,
 * restores after 3s of silence.
 */
export default function useAudioDucking({ ariaSpeaking, micSpeaking, loading }) {
  const audioDuckedRef = useRef(false);
  const duckRestoreTimerRef = useRef(null);

  useEffect(() => {
    if (!window.electronAPI?.duckSystemAudio) return;

    const conversationActive = ariaSpeaking || micSpeaking || loading;

    if (conversationActive && !audioDuckedRef.current) {
      if (duckRestoreTimerRef.current) { clearTimeout(duckRestoreTimerRef.current); duckRestoreTimerRef.current = null; }
      audioDuckedRef.current = true;
      window.electronAPI.duckSystemAudio().catch(() => {});
    } else if (!conversationActive && audioDuckedRef.current) {
      if (duckRestoreTimerRef.current) clearTimeout(duckRestoreTimerRef.current);
      duckRestoreTimerRef.current = setTimeout(() => {
        duckRestoreTimerRef.current = null;
        audioDuckedRef.current = false;
        window.electronAPI.restoreSystemAudio?.().catch(() => {});
      }, DUCK_RESTORE_DELAY_MS);
    } else if (conversationActive && audioDuckedRef.current) {
      if (duckRestoreTimerRef.current) { clearTimeout(duckRestoreTimerRef.current); duckRestoreTimerRef.current = null; }
    }
  }, [ariaSpeaking, micSpeaking, loading]);

  useEffect(() => () => {
    if (duckRestoreTimerRef.current) clearTimeout(duckRestoreTimerRef.current);
  }, []);
}
